import { render, staticRenderFns } from "./pt-challan.vue?vue&type=template&id=5fa59b8e&"
import script from "./pt-challan.vue?vue&type=script&lang=js&"
export * from "./pt-challan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports